

export const concatenatePageToUri = (uri, page) => {
  return page ? `${uri}?page=${page + 1}` : uri;
}